/**
 *
 * @todo this file is getting too large and verbose. Should think about using `combineReducers`
 *
 */
import {groupQuestionsByDriver, filterEnabledQuestions} from "@irati/insights/helpers/question"

import {
  UPDATE_TENANT,
  UPDATE_DRIVERS,
  LOAD_QUESTIONS,
  UPDATE_QUESTIONS,
  EDITING_QUESTION_ID,
  PUT_OVERRIDES
} from "../actions/questionLibrary"

import {AnalysisReducer, ReportReducer} from "./"

/**
 * Default insights store state
 *
 * @returns {{analysisFilters: {}}}
 * @private
 */
const _getDefaultState = () => ({
  drivers: []
})

const Insights = (state = _getDefaultState(), action) => {
  const {type} = action

  switch (type) {
    case UPDATE_TENANT:
      return {
        ...state,
        tenant: action.tenant
      }
    case UPDATE_DRIVERS:
      return {
        ...state,
        drivers: action.drivers
      }
    case LOAD_QUESTIONS:
      return {
        ...state,
        loadQuestionsPromise: action.loadQuestionsPromise
      }
    case UPDATE_QUESTIONS:
      return {
        ...state,
        questions: groupQuestionsByDriver(filterEnabledQuestions(action.questions), null),

        /** everytime the question list updates reset the state */
        editingQuestionId: null,
        putOverridesPromise: null
      }
    case EDITING_QUESTION_ID:
      return {
        ...state,
        editingQuestionId: action.questionId,
        putOverridesPromise: null
      }
    case PUT_OVERRIDES:
      return {
        ...state,
        putOverridesPromise: action.putOverridesPromise
      }
    default:
      return state
  }
}

const InsightsReducer = (state = _getDefaultState(), action) => {
  return {
    ...Insights(state, action),
    analysis: AnalysisReducer(state.analysis, action),
    reports: ReportReducer(state.reports, action)
  }
}

export default InsightsReducer
